// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__oVX93","actions":"GroupTable_actions__3QAXz","deleteModalFooter":"GroupTable_deleteModalFooter__2AVEe"};